enum ClientType {
  OktaInternal = 'oktaInternal',
  OktaExternal = 'oktaExternal',
  PartnerApp = 'partnerApp',
}

interface ProfileResult {
  partnerPositionId: string;
  isCorporate?: boolean;
}

interface QueryResult {
  data: {
    profileInformation: ProfileResult;
  };
}

export { ClientType };
export type { ProfileResult, QueryResult };
